module.exports = __webpack_public_path__ + "d324e1c4279f39a2bcbea33524aef310.png";